module.exports = __webpack_public_path__ + "static/media/2.5796d256.mp3";